/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types */
import {
  Component,
} from '@angular/core';

import {
  Router
} from '@angular/router';

import { Logger         } from '../util/logger';
import { StatusReporter } from '../util/status.reporter';



@Component({
  selector: 'app-root',
  template: `<alert style="margin-bottom: 0;"></alert><router-outlet></router-outlet>`
})

export class AppComponent {

  private title: string   = 'project-manager';

  constructor(
    private router: Router
  ) {



  }


}
